import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const useQuestionBank = () => {
  const user = useSelector((state) => state?.user?.data);
  return user?.questionBank;
};

export const useIsMainSubscribed = () => {
  const user = useSelector((state) => state?.user?.data);
  return user?.subscribed ?? false;
};

export const useIsQbSubscribed = () => {
  const user = useSelector((state) => state?.user?.data);
  return user?.questionBank?.subscribed ?? false;
};

export const useIsSubscribedAny = () => {
  const main = useIsMainSubscribed();
  const qb = useIsQbSubscribed();
  return main || qb;
};

export const useIsSubscribedBoth = () => {
  const main = useIsMainSubscribed();
  const qb = useIsQbSubscribed();
  return main && qb;
};

export const useSubsciptionGuard = () => {
  const subscribed = useIsQbSubscribed();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!subscribed) {
        window.location.href = '/subscriptions';
      }
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [subscribed]);
};
